export default __webpack_public_path__ + "static/media/liveTrackGold.dd8b92cb.gif";